import i18n from "../../../public/i18n";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import PrivacyTipRoundedIcon from "@mui/icons-material/PrivacyTipRounded";
import CustomBotIcon from "../../app/assets/custom-icons/CustomBotIcon";
import CustomDashboardIcon from "../../app/assets/custom-icons/CustomDashboardIcon";
import CustomInbox from "../../app/assets/custom-icons/CustomInbox";
import CustomPaperworkManagementIcon from "../../app/assets/custom-icons/CustomPaperworkManagementIcon";
import DocumentiUserPage from "../../features/admin/GestioneDocumentiPage/GestioneDocumentiFolders/Folders/DocumentiUserPage";
import FolderMacrocat from "../../features/admin/GestioneDocumentiPage/GestioneDocumentiFolders/Folders/FolderMacrocat";
import GestioneDocumentiFolders from "../../features/admin/GestioneDocumentiPage/GestioneDocumentiFolders/Folders/GestioneDocumentiFolders";
import FolderExpenseDoc from "../../features/admin/GestioneDocumentiPage/GestioneDocumentiFolders/Folders/FolderExpenseDoc";
import GestioneDocumentiPage2 from "../../features/admin/GestioneDocumentiPage/GestioneDocumentiPage";
import GestisciPratichePage from "../../features/admin/GestisciPratichePage/GestisciPratichePage";
import ChatBotPage from "../../features/common/ChatBotPage/ChatBotPage";
import ChatPage from "../../features/common/ChatPage/ChatPage";
import DashboardPage from "../../features/common/DashboardPage/DashboardPage";
import SettingsChatBot from "../../features/common/ChatBotPage/SettingsChatBot";
import CustomStudioServicesIcons from "../../app/assets/custom-icons/CustomStudioServicesIcons";
import CustomFactoryIcon from "../../app/assets/custom-icons/CustomFactoryIcon";
import GestioneCompany from "../../features/common/FormCompany/GestioneCompany";
import GestisciStudioPage from "../../features/admin/GestisciStudioPage/GestisciStudioPage";
import CustomOperatorIcon from "../../app/assets/custom-icons/CustomOperatorIcon";
import GestisciCommercialistiPage from "../../features/admin/GestisciCommercialistiPage/GestisciCommercialistiPage";
import GestioneNews from "../../features/common/GestisciNews/GestioneNews";
import CustomNewsIcon from "../../app/assets/custom-icons/CustomNewsIcon";
import CreaNews from "../../features/common/GestisciNews/CreaNews/CreaNews";
import SchedaStudio from "../../features/common/SchedaStudio/SchedaStudio";
import SinglePraticaPage from "../../features/admin/GestisciPratichePage/SinglePraticaPage/SinglePraticaPage";
import DocumentiPage from "../../features/admin/GestisciPratichePage/SinglePraticaPage/DocumentiPage";
import CreaStudio from "../../features/admin/GestisciStudioPage/CreaStudio";
import SchedaCompany from "../../features/common/FormCompany/SchedaCompany";
import { FormCompany } from "../../features/common/FormCompany/FormCompany";
import CustomCalendar from "../../app/assets/custom-icons/CustomCalendar";
import NotifichePage from "../../features/common/NotifichePage/NotifichePage";
import CustomCategory from "../../app/assets/custom-icons/CustomCategory";
import ExtendDocCategoriesPage from "../../features/admin/ExtendDocCategories/ExtendDocCategoriesPage";
import GestionePrompt from "../../features/admin/GestionePrompt/GestionePrompt";
import CustomPromptIcon from "../../app/assets/custom-icons/CustomPromptIcon";
import GestioneRuoli from "../../features/admin/GestioneRuoli/GestioneRuoli";
import CustomRolesIcon from "../../app/assets/custom-icons/CustomRolesIcon";
import CaricaDocumentiPage from "../../features/admin/CaricaDocumentiPage/CaricaDocumentiPage";
import CreaUtentePage from "../../features/admin/CreaUtentePage/CreaUtentePage";
import ModificaProfiloPage from "../../features/admin/ModificaProfiloPage/ModificaProfiloPage";
import AssistenzaPage from "../../features/admin/AssistenzaPage/AssistenzaPage";
import TerminiCondizioniPage from "../../features/common/TerminiCondizioniPage/TerminiCondizioniPage";
import NewsPage from "../../features/common/NewsPage/NewsPage";
import NewsDetailPage from "../../features/common/NewsPage/NewsDetailPage";
import GestisciUtentiPage from "../../features/admin/GestisciUtentiPage/GestisciUtentiPage";
import CustomManageUsersIcon from "../../app/assets/custom-icons/CustomManageUsersIcon";
import CustomDocManagementIcon from "../../app/assets/custom-icons/CustomDocManagementIcon";
import ServiziPage from "../../features/admin/ServiziPage/ServiziPage";
import CustomStudioManagementIcon from "../../app/assets/custom-icons/CustomStudioManagementIcon";
import SchedaCommercialista from "../../features/common/SchedaOperatore/SchedaCommercialista";
import PersonalizzaStudio from "../../features/admin/GestisciCommercialistiPage/PersonalizzaStudio/PersonalizzaStudio";
import ServiziStudioPage from "../../features/admin/ServiziStudioPage/ServiziStudioPage";
import { ROLE } from "../../utils/constants/profiles";

export const routesAdmin = (appConfig, role) => [
    {
        path: i18n.t("dashboard"),
        label: i18n.t("Dashboard"),
        name: "dashboard",
        capabilities: ["Dashboard"],
        component: <DashboardPage />,
        icon: <CustomDashboardIcon className="w-10 h-10" />,
        isSidebarElement: true,
        isTopbarElement: false,
        ai: false,
        order: 0
    },
    {
        path: i18n.t("manageUsers"),
        label: i18n.t("Users"),
        name: "lista-utenti",
        component: <GestisciUtentiPage />,
        icon: <CustomManageUsersIcon className="w-10 h-10" />,
        capabilities: ["ManagementUsers"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: false,
        order: appConfig?.sectionsOrderAdmin?.indexOf("users"),
    },
    {
        path: i18n.t("create-account"),
        name: "crea-utente",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <CreaUtentePage />,
    },
    {
        path: i18n.t("documentManagement"),
        label: i18n.t("Archive"),
        name: "lista-documenti",
        component: <GestioneDocumentiPage2 />,
        icon: <CustomDocManagementIcon className="w-10 h-10" />,
        capabilities: ["Document"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: true,
        order: appConfig?.sectionsOrderAdmin?.indexOf("documents"),
    },
    {
        path: i18n.t("uploadDocuments"),
        name: "carica-documenti",
        capabilities: ["Document"],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <CaricaDocumentiPage />,
    },
    {
        path: `${i18n.t("documentManagement")}/folder`,
        component: <GestioneDocumentiFolders />,
        name: "cartella-user",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
    },
    {
        path: `${i18n.t("documentManagement")}/folder/:id`,
        name: "cartella-lista-categoria",
        component: <FolderMacrocat />,
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
    },
    {
        path: `${i18n.t("documentManagement")}/folder/:id/documenti`,
        name: "cartella-lista-documenti",
        component: <FolderExpenseDoc />,
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
    },
    {
        path: `${i18n.t("documentManagement")}/folder/:id/documenti/archivio`,
        name: "cartella-archivio",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <DocumentiUserPage />,
    },
    {
        path: i18n.t("managePractices"),
        label: i18n.t("Practice"),
        name: "lista-attivita",
        component: <GestisciPratichePage />,
        icon: <CustomPaperworkManagementIcon className="w-10 h-10" />,
        capabilities: ["Practice"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: true,
        order: appConfig?.sectionsOrderAdmin?.indexOf("practices"),
    },
    {
        path: `${i18n.t("singlePracticeRoute")}/:Id`,
        name: "singola-attivita",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <SinglePraticaPage />,
    },
    {
        path: `${i18n.t("singlePracticeRoute")}/:Id/${i18n.t("documents")}`,
        name: "documenti-attivita",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <DocumentiPage />,
    },
    {
        path: i18n.t("chat"),
        label: i18n.t("Chat"),
        name: "chat",
        component: <ChatPage />,
        icon: <CustomInbox className="w-10 h-10" />,
        capabilities: ["Chat"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: false,
        order: appConfig?.sectionsOrderAdmin?.indexOf("chat"),
    },
    {
        path: "chat-bot",
        label: i18n.t("SmartAssistant"),
        name: "chat-bot",
        component: <ChatBotPage />,
        icon: <CustomBotIcon className="w-10 h-10" />,
        capabilities: ["Chatbot"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: true,
        order: appConfig?.sectionsOrderAdmin?.indexOf("chat-bot"),
    },
    {
        path: "chat-bot-settings",
        name: "chatbot-impostazioni",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <SettingsChatBot />,
    },
    {
        path: i18n.t("services"),
        label: i18n.t("Services"),
        name: "lista-servizi",
        component: role === ROLE.ADMIN ? <ServiziPage /> : <ServiziStudioPage />,
        icon: <CustomStudioServicesIcons className="w-10 h-10" />,
        capabilities: ["Services"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: true,
        order: appConfig?.sectionsOrderAdmin?.indexOf("services"),
    },
    {
        path: i18n.t("manage-company"),
        label: i18n.t("Companies"),
        name: "lista-azienda",
        component: <GestioneCompany />,
        icon: <CustomFactoryIcon className="w-10 h-10" />,
        capabilities: ["Company"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: false,
        order: appConfig?.sectionsOrderAdmin?.indexOf("companies"),
    },
    {
        path: i18n.t("create-company"),
        name: "crea-azienda",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <FormCompany isEdit={false} />,
    },
    {
        path: `${i18n.t("edit-company")}/:id`,
        name: "scheda-azienda",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <SchedaCompany />,
    },

    {
        path: i18n.t("studios"),
        label: i18n.t("Studios"),
        name: "lista-studi",
        component: <GestisciStudioPage />,
        icon: <CustomStudioManagementIcon className="w-10 h-10" />,
        capabilities: ["ManagementStudios"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: false,
        order: appConfig?.sectionsOrderAdmin?.indexOf("studios"),
    },
    {
        path: `${i18n.t("studios")}/${i18n.t("createStudioRoute")}`,
        name: "crea-studio",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <CreaStudio />,
    },
    {
        path: `${i18n.t("studiosRoute")}/:id`,
        name: "scheda-studio",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <SchedaStudio />,
    },
    {
        path: i18n.t("operators"),
        label: i18n.t("Operators"),
        name: "lista-operatori",
        component: <GestisciCommercialistiPage />,
        icon: <CustomOperatorIcon className="w-10 h-10" />,
        capabilities: ["ManagementOperators"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: false,
        order: appConfig?.sectionsOrderAdmin?.indexOf("operators"),
    },
    {
        path: `${i18n.t("customize-studio")}`,
        name: "personalizza-studio",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <PersonalizzaStudio />,
    },
    {
        path: `${i18n.t("operators")}/:id`,
        name: "scheda-operatore",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <SchedaCommercialista />,
    },
    {
        path: i18n.t("manage-news"),
        label: i18n.t("News"),
        name: "lista-news",
        component: role === ROLE.ADMIN || role === ROLE.STUDIO ? <GestioneNews /> : <NewsPage />,
        icon: <CustomNewsIcon className="w-10 h-10" />,
        capabilities: ["News"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: false,
        order: appConfig?.sectionsOrderAdmin?.indexOf("news"),
    },
    {
        path: `${i18n.t("manage-news")}/news`,
        name: "detail-news",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: role === ROLE.ADMIN || role === ROLE.STUDIO ? <CreaNews /> : <NewsDetailPage />,
    },
    {
        path: i18n.t("manage-deadline"),
        label: i18n.t("Deadlines"),
        name: "calendario-scadenze",
        component: <NotifichePage />,
        icon: <CustomCalendar className="w-10 h-10" />,
        capabilities: ["Deadlines"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: false,
        order: appConfig?.sectionsOrderAdmin?.indexOf("deadlines"),
    },
    {
        path: "extend-doc-categories",
        label: i18n.t("ExtCategoriesShort"),
        name: "classificatore-documenti",
        component: <ExtendDocCategoriesPage />,
        icon: <CustomCategory className="w-10 h-10" />,
        capabilities: ["ExCategories"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: true,
        order: appConfig?.sectionsOrderAdmin?.indexOf("categories"),
    },
    {
        path: i18n.t("manage-prompt"),
        label: "Prompt",
        name: "gestione-prompt",
        component: <GestionePrompt />,
        icon: <CustomPromptIcon className="w-10 h-10" />,
        capabilities: ["Prompt"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: true,
        order: appConfig?.sectionsOrderAdmin?.indexOf("prompt"),
    },
    {
        path: i18n.t("manage-roles"),
        label: i18n.t("RolesPermitted"),
        name: "gestione-ruoli",
        component: <GestioneRuoli />,
        icon: <CustomRolesIcon className="w-10 h-10" />,
        capabilities: ["IdentityRole"],
        isSidebarElement: true,
        isTopbarElement: false,
        ai: false,
        order: appConfig?.sectionsOrderAdmin?.indexOf("roles"),
    },
    // Settings
    {
        path: i18n.t("profile"),
        label: i18n.t("Profile"),
        name: "profile",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: true,
        component: <ModificaProfiloPage />,
        icon: <PersonRoundedIcon />,
    },
    {
        path: i18n.t("assistance"),
        label: i18n.t("Assistance"),
        name: "assistance",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: false,
        component: <AssistenzaPage />,
    },
    {
        path: i18n.t("terms-and-conditions"),
        label: i18n.t("TermsAndConditions"),
        name: "terms",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: true,
        component: <TerminiCondizioniPage />,
        icon: <ReceiptLongRoundedIcon />,
    },
    {
        path: "privacy",
        name: "privacy",
        label: "Privacy policy",
        capabilities: [],
        isSidebarElement: false,
        isTopbarElement: true,
        icon: <PrivacyTipRoundedIcon />,
    },
];